(() => {
  const preference = matchMedia('(prefers-reduced-motion: reduce)');
  const visible = new Set();
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => { if (entry.isIntersecting) visible.add(entry.target); else visible.delete(entry.target); });
    update();
  }, { threshold: 0 }) : null;
  function update() {
    document.querySelectorAll('[data-ss-motion]').forEach(element => {
      element.dataset.ssMotionActive = String(!document.hidden && !preference.matches && !navigator.connection?.saveData && (observer ? visible.has(element) : true));
    });
    for (const element of visible) if (!element.isConnected) { visible.delete(element); observer?.unobserve(element); }
  }
  function init(root = document) { root.querySelectorAll('[data-ss-motion]').forEach(element => observer?.observe(element)); update(); }
  document.addEventListener('visibilitychange', update);
  preference.addEventListener('change', update);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => { event.target.querySelectorAll('[data-ss-motion]').forEach(element => { visible.delete(element); observer?.unobserve(element); }); });
  window.addEventListener('pageshow', update);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true }); else init();
})();
